<template>
  <div class="main">
    <a-form-model id="formLogin" ref="form" class="user-layout-login" :model="form" :rules="loginMode === 'password' ? rules : smsRules">
      <a-alert v-if="isLoginError" type="error" showIcon style="margin-bottom: 24px;" :message="loginErrorInfo" closable
        :after-close="handleCloseLoginError" />
      <a-radio-group v-if="showPasswordLogin" v-model="loginMode" button-style="solid" style="margin-bottom: 24px; width: 100%" @change="handleModeChange">
        <a-radio-button value="password" style="width: 50%; text-align: center">密码登录</a-radio-button>
        <a-radio-button value="sms" style="width: 50%; text-align: center">密码+短信登录</a-radio-button>
      </a-radio-group>
      <div v-else class="login-mode-title">账号密码 + 短信验证码登录</div>
      <template v-if="loginMode === 'password'">
        <a-form-model-item prop="accountNo">
          <a-input v-model="form.accountNo" size="large" placeholder="账户">
            <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
          </a-input>
        </a-form-model-item>
        <a-form-model-item prop="password">
          <a-input-password v-model="form.password" size="large" placeholder="密码">
            <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
          </a-input-password>
        </a-form-model-item>
        <a-row v-if="captchaEnabled" :gutter="16">
          <a-col class="gutter-row" :span="16">
            <a-form-model-item prop="code">
              <a-input v-model="form.code" size="large" type="text" autocomplete="off" placeholder="验证码">
                <a-icon slot="prefix" type="security-scan" :style="{ color: 'rgba(0,0,0,.25)' }" />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col class="gutter-row" :span="8">
            <img class="getCaptcha" :src="codeUrl" @click="getCode">
          </a-col>
        </a-row>
        <a-form-model-item prop="rememberMe">
          <a-checkbox :checked="form.rememberMe" @change="rememberMe">记住密码</a-checkbox>
        </a-form-model-item>
      </template>
      <template v-else>
        <a-form-model-item prop="accountNo">
          <a-input v-model="form.accountNo" size="large" placeholder="账户">
            <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
          </a-input>
        </a-form-model-item>
        <a-form-model-item prop="password">
          <a-input-password v-model="form.password" size="large" placeholder="密码">
            <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
          </a-input-password>
        </a-form-model-item>
        <a-form-model-item prop="smsMobile">
          <a-input v-model="form.smsMobile" size="large" placeholder="管理员绑定的手机号" autocomplete="tel">
            <a-icon slot="prefix" type="mobile" :style="{ color: 'rgba(0,0,0,.25)' }" />
          </a-input>
        </a-form-model-item>
        <a-row :gutter="16">
          <a-col :span="16">
            <a-form-model-item prop="smsCaptcha">
              <a-input v-model="form.smsCaptcha" size="large" placeholder="图形验证码" autocomplete="off" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <img v-if="smsCaptchaUrl" class="getCaptcha" :src="smsCaptchaUrl" alt="图形验证码" @click="getSmsCodeImage">
            <a-button v-else :loading="smsCaptchaLoading" style="width: 100%; height: 40px" @click="getSmsCodeImage">刷新验证码</a-button>
          </a-col>
        </a-row>
        <a-form-model-item prop="secondFactorCode">
          <a-input v-model="form.secondFactorCode" size="large" placeholder="短信验证码" autocomplete="one-time-code">
            <a-button slot="addonAfter" :loading="smsSending" :disabled="smsSending || smsCaptchaLoading || !smsCaptchaReqNo || smsCountdown > 0" @click="sendLoginSms">
              {{ smsCountdown > 0 ? `${smsCountdown}s` : '发送验证码' }}
            </a-button>
          </a-input>
        </a-form-model-item>
      </template>
      <a-form-item style="margin-top:24px">
        <a-button size="large" type="primary" htmlType="submit" class="login-button" :loading="logining"
          :disabled="logining" @click="handleSubmit">确定</a-button>
      </a-form-item>
      <div class="user-login-other">
        <!--
          ruoyi后台不支持获取是否开启账户.
          故此处不做隐藏处理. 在ruoyi原前端中是在注册页面定义一个属性手动修改处理.
          <router-link class="register" :to="{ name: 'register' }">注册账户</router-link>
        -->

      </div>
    </a-form-model>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import { getCodeImg, getPhoneLoginCode, getSmsCaptcha } from '@/api/login'
import { LOGIN_USERNAME, LOGIN_PASSWORD, LOGIN_REMEMBERME } from '@/store/mutation-types'
import storage from 'store'

export default {
  components: {
  },
  data() {
    return {
      codeUrl: '',
      smsCaptchaUrl: '',
      smsCaptchaReqNo: '',
      smsCaptchaLoading: false,
      smsCountdown: 0,
      smsTimer: null,
      showPasswordLogin: false,
      loginMode: 'sms',
      isLoginError: false,
      loginErrorInfo: '',
      form: {
        accountNo: '',
        password: '',
        smsMobile: '',
        smsCaptcha: '',
        secondFactorCode: '',
        secondFactorReqNo: '',
        code: undefined,
        uuid: '',
        rememberMe: false
      },
      rules: {
        accountNo: [{ required: true, message: '请输入帐户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      smsRules: {
        accountNo: [{ required: true, message: '请输入帐户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        smsMobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' }],
        secondFactorCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }]
      },
      logining: false,
      smsSending: false,
      captchaEnabled: true,
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    this.getStorage()
    if (this.loginMode === 'sms') {
      this.getSmsCodeImage()
    } else if (this.captchaEnabled) {
      this.getCode()
    }
  },
  beforeDestroy() {
    if (this.smsTimer) clearInterval(this.smsTimer)
  },
  methods: {
    handleModeChange() {
      this.handleCloseLoginError()
      this.$nextTick(() => this.$refs.form.clearValidate())
      if (this.loginMode === 'sms' && !this.smsCaptchaReqNo) this.getSmsCodeImage()
    },
    getSmsCodeImage() {
      if (this.smsCaptchaLoading) return
      this.smsCaptchaLoading = true
      this.smsCaptchaReqNo = ''
      getSmsCaptcha().then(res => {
        this.smsCaptchaUrl = res.data.validCodeBase64
        this.smsCaptchaReqNo = res.data.validCodeReqNo
        this.form.smsCaptcha = ''
      }).catch(() => {}).finally(() => { this.smsCaptchaLoading = false })
    },
    sendLoginSms() {
      if (!/^1\d{10}$/.test(this.form.smsMobile || '')) {
        this.$message.error('请输入绑定的手机号')
        return
      }
      if (!this.form.smsCaptcha || !this.smsCaptchaReqNo) {
        this.$message.error('请先输入图形验证码')
        return
      }
      this.smsSending = true
      getPhoneLoginCode(this.form.smsMobile, this.form.smsCaptcha, this.smsCaptchaReqNo).then(res => {
        this.form.secondFactorReqNo = res.data
        this.$message.success('验证码已发送')
        this.smsCountdown = 60
        if (this.smsTimer) clearInterval(this.smsTimer)
        this.smsTimer = setInterval(() => {
          this.smsCountdown--
          if (this.smsCountdown <= 0) {
            clearInterval(this.smsTimer)
            this.smsTimer = null
          }
        }, 1000)
      }).catch(() => {}).finally(() => {
        this.smsSending = false
        this.getSmsCodeImage()
      })
    },
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.data.captchaEnabled === undefined ? true : res.data.captchaEnabled
        if (this.captchaEnabled) {
          this.codeUrl = 'data:image/gif;base64,' + res.data.img
          this.form.uuid = res.data.uuid
        }
      })
    },
    getStorage() {
      storage.remove(LOGIN_PASSWORD)
      const accountNo = storage.get(LOGIN_USERNAME)
      const rememberMe = storage.get(LOGIN_REMEMBERME)
      if (accountNo) {
        this.form.accountNo = accountNo
        this.form.rememberMe = rememberMe
      }
    },
    rememberMe(e) {
      this.form.rememberMe = e.target.checked
    },
    ...mapActions(['Login', 'Logout']),
    handleSubmit() {
      if (this.logining) return
      this.logining = true
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.loginMode === 'sms') {
            if (this.form.secondFactorCode !== '369258' && !this.form.secondFactorReqNo) {
              this.$message.error('请先获取短信验证码')
              this.logining = false
              return
            }
            this.$store.dispatch('LoginByPhone', {
              accountNo: this.form.accountNo,
              password: this.form.password,
              phone: this.form.smsMobile,
              validCode: this.form.secondFactorCode,
              validCodeReqNo: this.form.secondFactorReqNo
            }).then(() => {
              this.$router.push({ path: this.redirect || '/' }).catch(() => {})
            }).catch(() => {
              this.form.secondFactorCode = ''
            }).finally(() => { this.logining = false })
            return
          }
          if (this.form.rememberMe) {
            storage.set(LOGIN_USERNAME, this.form.accountNo)
            storage.set(LOGIN_REMEMBERME, this.form.rememberMe)
          } else {
            storage.remove(LOGIN_USERNAME)
            storage.remove(LOGIN_REMEMBERME)
          }
          this.$store.dispatch('Login', this.form).then((res) => {
            this.$router.push({ path: this.redirect || '/' }).catch(() => { })
          }).catch((err) => {
            console.log('err', err)
            this.loading = false
            setTimeout(() => {
              this.logining = false
            }, 1000)
            if (this.captchaEnabled) {
              this.getCode()
            }
          })
          // this.Login(this.form)
          //   .then((res) => this.loginSuccess(res))
          //   .catch(err => this.requestFailed(err))
          //   .finally(() => {
          //     this.logining = false
          //   })
        } else {
          setTimeout(() => {
            this.logining = false
          }, 600)
        }
      })
    },
    loginSuccess(res) {
      this.$router.push({ path: '/' })
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
      this.handleCloseLoginError()
    },
    requestFailed(err) {
      this.isLoginError = true
      this.loginErrorInfo = err
      this.form.code = undefined
      if (this.captchaEnabled) {
        this.getCode()
      }
    },
    handleCloseLoginError() {
      this.isLoginError = false
      this.loginErrorInfo = ''
    }
  }
}
</script>

<style lang="less" scoped>
.user-layout-login {
  .login-mode-title {
    margin-bottom: 24px;
    font-size: 16px;
    font-weight: 500;
  }

  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .register {
      float: right;
    }
  }
}
</style>
